import { render, staticRenderFns } from "./CarouselModal.vue?vue&type=template&id=18f635e6&"
import script from "./CarouselModal.vue?vue&type=script&lang=ts&"
export * from "./CarouselModal.vue?vue&type=script&lang=ts&"
import style0 from "./CarouselModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports